import { render, staticRenderFns } from "./SimilarMedsDialog.vue?vue&type=template&id=20437496&scoped=true&"
import script from "./SimilarMedsDialog.vue?vue&type=script&lang=js&"
export * from "./SimilarMedsDialog.vue?vue&type=script&lang=js&"
import style0 from "./SimilarMedsDialog.vue?vue&type=style&index=0&id=20437496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20437496",
  null
  
)

export default component.exports